import { lazy, Suspense } from 'react';

const LazyComponent = lazy(() =>
    import(/* webpackChunkName: "SbSharedEmptyDesignsBanner" */ './SbSharedEmptyDesignsBanner')
);

export const SbSharedEmptyDesignsBannerLazy = props => (
    <Suspense fallback="">
        <LazyComponent {...props} />
    </Suspense>
);
